import React, { Component } from "react";

export default class CloudInfraImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={864.81}
        height={658.47}
        viewBox="0 0 660.62 658.47"
      >
        <defs>
          <linearGradient
            id="a"
            x1={477.04}
            y1={-119.22}
            x2={477.04}
            y2={539.25}
            gradientTransform="matrix(1 0 0 -1 -167.6 539.22)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="gray" stopOpacity={0.25} />
            <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
            <stop offset={1} stopColor="gray" stopOpacity={0.1} />
          </linearGradient>
          <linearGradient
            id="b"
            x1={309.42}
            y1={37}
            x2={309.42}
            y2={199}
            gradientTransform="matrix(1 0 0 -1 0 660.03)"
            xlinkHref="#a"
          />
        </defs>
        <path
          d="M338.8 353.16l-.59-.14v-22.6A120.22 120.22 0 00428 233.33h.29c5.77 0 10.44-8.77 10.44-19.58 0-6.71-1.8-12.62-4.54-16.15q.62-6.19.63-12.57a125 125 0 00-38.62-90.49 80.52 80.52 0 00-8.87-23.81c-8.9-15.68-23.71-32-17.67-49l-39.1 4L330.2 0c-12.2 2.16-17.31 16.3-24.55 26.37C288.24 50.59 253.3 54 230.19 72.82c-7.85 6.41-25.51 25.9-22.19 38.68a125.37 125.37 0 00-23.21 86.1c-2.74 3.53-4.54 9.44-4.54 16.15 0 10.82 4.68 19.58 10.44 19.58h.31a120.22 120.22 0 0089.79 97.09V353l-.59.14c-13.46-1.57-149.3-11.94-119.51 211.46l18.25 67.4 4.07-.16a28.72 28.72 0 0056.39 5.11c25.87-.09 55.09-.17 70-.17s44.18.09 70 .17a28.72 28.72 0 0056.44-5.11l4.07.16 18.27-67.36c29.93-223.42-105.92-213.05-119.38-211.48z"
          transform="translate(0 .03)"
          fill="url(#a)"
          opacity={0.699999988079071}
        />
        <path fill="#e0e0e0" d="M0 625.19H645.61V647.07H0z" />
        <path
          fill="#e0e0e0"
          d="M27.36 647.08H618.25V656.0300000000001H27.36z"
        />
        <path
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
          d="M27.36 647.08H618.25V650.0600000000001H27.36z"
        />
        <path
          d="M193.4 626.86s86.63-.34 116.09-.34 116.09.34 116.09.34v-12.61H193.4z"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M425.59 624.33s-86.59-.3-116.09-.3-116.09.34-116.09.34V465.03A116.09 116.09 0 01309.49 348.9a116.1 116.1 0 01116.1 116.13z"
          fill="#444"
        />
        <path
          d="M298.5 290.86h22a16.76 16.76 0 0116.76 16.76v46.33a27.76 27.76 0 01-27.76 27.76 27.76 27.76 0 01-27.76-27.76v-46.33a16.76 16.76 0 0116.76-16.76z"
          fill="#fdb797"
        />
        <path
          d="M281.73 332.92a116.1 116.1 0 0055.52 0v-39.54h-55.52z"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <circle cx={309.5} cy={189.91} r={121.14} fill="#333" />
        <circle cx={309.5} cy={217.67} r={116.09} fill="#fdb797" />
        <path
          d="M232.84 81.44c22.33-18.23 56.11-21.48 72.94-44.9 7-9.73 11.93-23.4 23.73-25.52l.35 24.9 37.79-3.89c-5.83 16.42 8.48 32.23 17.08 47.38a78 78 0 0110.09 36.68c-13.12 7.88-29.39-.72-44-5.31-14.2-4.46-29.29-4.92-44.17-5.34-7.63-.22-15.35-.42-22.8 1.25-6.53 1.47-12.64 4.34-18.82 6.93-10 4.21-41.79 20.09-51.13 9.85-10.58-11.6 10.32-34.99 18.94-42.03z"
          fill="#333"
        />
        <path
          d="M239.15 159.45c6.16 3.73 13.4 5.2 20.53 6.18a180.87 180.87 0 0088.11-9.9c4.6 11.66 15.83 19.67 27.77 23.48s24.69 4 37.22 4.15c2.76 0 5.72 0 8-1.53 5.58-3.77 2.88-12.4-.37-18.3l-16.17-29.28c-4.78-8.66-9.7-17.5-17.1-24.06-9.28-8.21-21.6-12.06-33.75-14.49a190.45 190.45 0 00-86.64 2.89c-30.22 8.13-69.04 35.78-27.6 60.86z"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <path
          d="M239.15 156.93c6.16 3.73 13.4 5.2 20.53 6.18a180.87 180.87 0 0088.11-9.9c4.6 11.66 15.83 19.67 27.77 23.48s24.69 4 37.22 4.15c2.76 0 5.72 0 8-1.53 5.58-3.77 2.88-12.4-.37-18.3l-16.17-29.32c-4.78-8.66-9.7-17.5-17.1-24.06-9.28-8.21-21.6-12.06-33.75-14.49a190.45 190.45 0 00-86.64 2.89c-30.22 8.16-69.04 35.81-27.6 60.9z"
          fill="#333"
        />
        <ellipse cx={424.33} cy={217.67} rx={10.1} ry={18.93} fill="#fdb797" />
        <ellipse cx={194.67} cy={217.67} rx={10.1} ry={18.93} fill="#fdb797" />
        <path
          d="M336.79 352.52s146.84-22.87 116.56 204.27l-17.66 65.11-50.48-2s32.79-75.71 12.62-126.19-61.04-141.19-61.04-141.19zM282.2 352.52s-146.8-22.87-116.56 204.27l17.66 65.11 50.48-2S201 544.19 221.16 493.71s61.04-141.19 61.04-141.19z"
          fill="#444"
        />
        <path
          d="M218.64 452.61s-10.1 78 7.57 100.71M400.35 454.61s10.1 76-7.57 98.71"
          style={{
            isolation: "isolate",
          }}
          opacity={0.10000000149011612}
        />
        <circle cx={404.08} cy={619.71} r={27.76} fill="#fdb797" />
        <circle cx={214.91} cy={619.71} r={27.76} fill="#fdb797" />
        <rect
          x={218.04}
          y={461.03}
          width={182.77}
          height={162}
          rx={21.34}
          fill="url(#b)"
          opacity={0.699999988079071}
        />
        <rect
          x={221.42}
          y={464.03}
          width={176}
          height={156}
          rx={21.34}
          fill="#e0e0e0"
        />
        <path
          d="M557.19 369.94a14.6 14.6 0 00.53 4.26 26.6 26.6 0 001.53 3.45 2.06 2.06 0 01.34 1.1 1.88 1.88 0 01-.91 1.44l-3 2a2.32 2.32 0 01-1.25.43 2.26 2.26 0 01-1.44-.67 15.05 15.05 0 01-1.72-2.25 24.39 24.39 0 01-1.48-2.83 17.69 17.69 0 01-14.08 6.61c-4 0-7.23-1.15-9.58-3.45a13.51 13.51 0 01.81-19.06c2.92-2.49 6.8-3.74 11.73-3.74a37.51 37.51 0 015.08.38c1.77.24 3.59.62 5.51 1.05v-3.5c0-3.64-.77-6.18-2.25-7.66s-4.12-2.2-7.81-2.2a22 22 0 00-5.17.62 37.37 37.37 0 00-5.17 1.63 14.07 14.07 0 01-1.68.62 2.9 2.9 0 01-.77.14c-.67 0-1-.48-1-1.48v-2.35a3.07 3.07 0 01.34-1.68 3.58 3.58 0 011.34-1 27.93 27.93 0 016-2.16 29 29 0 017.47-.91c5.7 0 9.87 1.29 12.55 3.88s4 6.51 4 11.78v15.55zm-19.44 7.28a15.58 15.58 0 004.93-.86 10.67 10.67 0 004.55-3.07 7.6 7.6 0 001.63-3.07 17.28 17.28 0 00.48-4.17v-2a40.75 40.75 0 00-4.41-.81 35.54 35.54 0 00-4.5-.29c-3.21 0-5.56.62-7.14 1.92a6.84 6.84 0 004.45 12.36zm38.46 5.17a2.64 2.64 0 01-1.82-.48 4 4 0 01-1-1.87l-11.25-37a8.47 8.47 0 01-.43-1.92 1 1 0 01.88-1.19.82.82 0 01.27 0h4.69a2.65 2.65 0 011.87.48 3.88 3.88 0 011 1.87l8 31.71 7.47-31.71a3.4 3.4 0 01.91-1.87 3.34 3.34 0 011.92-.48h3.83a2.89 2.89 0 011.92.48 3.25 3.25 0 01.91 1.87l7.62 32.08 8.29-32.09a4.2 4.2 0 011-1.87 3.16 3.16 0 011.87-.48h4.45a1.06 1.06 0 011.2.9.76.76 0 010 .3 4 4 0 01-.1.77 6.31 6.31 0 01-.34 1.2l-11.54 37a3.64 3.64 0 01-1 1.87 3 3 0 01-1.82.48h-4.12a2.91 2.91 0 01-1.92-.48 3.41 3.41 0 01-.97-1.93l-7.42-30.89-7.37 30.89a3.77 3.77 0 01-.91 1.92 3 3 0 01-1.92.48zm61.54 1.29a31.67 31.67 0 01-7.38-.86 22 22 0 01-5.51-1.92 3.48 3.48 0 01-1.48-1.34 3.43 3.43 0 01-.29-1.34v-2.44c0-1 .38-1.48 1.1-1.48a2.82 2.82 0 01.86.14c.29.1.72.29 1.2.48a25.67 25.67 0 005.27 1.68 28.77 28.77 0 005.7.57 12.93 12.93 0 007-1.58 5.16 5.16 0 002.49-4.55 4.65 4.65 0 00-1.29-3.35 12 12 0 00-4.84-2.49l-7-2.16c-3.5-1.1-6.08-2.73-7.66-4.89a11.42 11.42 0 01-2.39-6.94 10.71 10.71 0 011.29-5.32 12.39 12.39 0 013.45-3.93 15.23 15.23 0 015-2.49 21 21 0 016-.81 23 23 0 013.21.19c1.1.14 2.11.34 3.11.53a20 20 0 012.73.77 10.14 10.14 0 012 .86 4.08 4.08 0 011.44 1.2 2.61 2.61 0 01.43 1.58v2.24c0 1-.38 1.53-1.1 1.53a4.9 4.9 0 01-1.82-.57 21.87 21.87 0 00-9.2-1.87 12.36 12.36 0 00-6.37 1.34 4.62 4.62 0 00-2.25 4.26 4.55 4.55 0 001.44 3.4 14.36 14.36 0 005.27 2.63l6.8 2.16c3.45 1.1 5.94 2.63 7.42 4.6a10.83 10.83 0 012.2 6.71 12.16 12.16 0 01-1.25 5.56 12.82 12.82 0 01-3.5 4.21 15.43 15.43 0 01-5.32 2.68 22.72 22.72 0 01-6.85 1z"
          fill="#252f3e"
        />
        <path
          d="M646.8 406.94c-15.76 11.64-38.65 17.82-58.33 17.82a105.52 105.52 0 01-71.22-27.16c-1.48-1.34-.14-3.16 1.63-2.11a141.42 141.42 0 00125.62 7.81c2.63-1.2 4.89 1.72 2.3 3.64z"
          fill="#f90"
        />
        <path
          d="M653.36 399.49c-2-2.59-13.31-1.25-18.44-.62-1.53.19-1.77-1.15-.38-2.16 9-6.32 23.8-4.5 25.53-2.39s-.48 17-8.91 24c-1.29 1.1-2.54.53-2-.91 1.95-4.71 6.21-15.38 4.2-17.92z"
          fill="#f90"
        />
        <path
          d="M523.34 248.44l-23.66-41 23.66-41h47.31l23.66 41-23.66 41h-47.31"
          fill="#cac9c2"
        />
        <path
          d="M547.81 226.17a18.44 18.44 0 1118.44-18.44 18.44 18.44 0 01-18.44 18.44"
          fill="#fff"
        />
        <path
          d="M584.89 152.75a10.14 10.14 0 00-7.91-4.57h-58.3a10.12 10.12 0 00-7.91 4.57l-17 29.5a9.65 9.65 0 001.06 5.35l11.53 19.71 20.58-35.56H592a9.51 9.51 0 014.76 1.5l-11.84-20.51"
          fill="#5072aa"
        />
        <path
          d="M494.48 180.97l-.75 1.29a9.65 9.65 0 001.06 5.35l11.53 19.71 6.13-10.6-18-15.76"
          fill="#4d6796"
        />
        <path
          d="M520.18 163.35a3.56 3.56 0 113.56-3.56 3.56 3.56 0 01-3.56 3.56m58.3-3.56a3.3 3.3 0 11-6.59.08v-.08a3.3 3.3 0 116.59 0z"
          fill="#fff"
        />
        <path
          d="M614 203.24l-17.31-30a9.51 9.51 0 00-4.76-1.5h-23.42l20.3 35.78-32.12 56.75a9.34 9.34 0 01-3.3 3.16H577a10.14 10.14 0 007.91-4.57l29.15-50.49a10.13 10.13 0 000-9.13"
          fill="#cc4232"
        />
        <path
          d="M597.51 174.61l-.78-1.35a9.51 9.51 0 00-4.76-1.5h-23.46l6.11 10.76 22.89-7.92"
          fill="#b23f33"
        />
        <path
          d="M575.18 258.71a3.56 3.56 0 113.56-3.56 3.56 3.56 0 01-3.56 3.56m27.69-47.42a3.56 3.56 0 113.56-3.56 3.56 3.56 0 01-3.56 3.56"
          fill="#fff"
        />
        <path
          d="M527.36 243.29l-32.55-55.68a9.65 9.65 0 01-1.06-5.35l-12.11 21a10.13 10.13 0 000 9.13l29.17 50.47a10.13 10.13 0 007.91 4.56h34.69a9.34 9.34 0 003.3-3.16l11.88-21h-41.23"
          fill="#ecb02a"
        />
        <path
          d="M551.4 267.43h2a9.34 9.34 0 003.3-3.16l11.88-21H556l-4.55 24.14"
          fill="#c79732"
        />
        <path
          d="M520.18 258.71a3.56 3.56 0 113.56-3.56 3.56 3.56 0 01-3.56 3.56m-27.74-47.42a3.56 3.56 0 113.56-3.56 3.56 3.56 0 01-3.56 3.56"
          fill="#fff"
        />
        <path
          d="M336.22 574.41a8.88 8.88 0 00-.92-7.82 7.92 7.92 0 00-6.31-3.09l-51.47-.67a1 1 0 01-.8-.42 1.12 1.12 0 01-.12-.92 1.4 1.4 0 011.21-.92l51.93-.67c6.15-.29 12.84-5.27 15.18-11.37l3-7.74a1.64 1.64 0 00.08-1 33.81 33.81 0 00-65-3.47 15.2 15.2 0 00-24.25 10.62 15.84 15.84 0 00.38 5.31 21.6 21.6 0 00-21 21.62 25.31 25.31 0 00.21 3.13 1 1 0 001 .88h95a1.3 1.3 0 001.21-.92z"
          fill="#f38020"
        />
        <path
          d="M352.61 541.34h-1.42a.84.84 0 00-.75.58l-2 7a8.88 8.88 0 00.92 7.81 7.94 7.94 0 006.32 3.1l10.95.67a.94.94 0 01.79.42 1.18 1.18 0 01.13.92 1.43 1.43 0 01-1.21.92l-11.42.66c-6.19.3-12.83 5.27-15.18 11.38l-.83 2.13a.6.6 0 00.58.84h39.21a1 1 0 001-.76 28.48 28.48 0 001-7.61 28.11 28.11 0 00-28.14-28.09"
          fill="#faae40"
        />
        <g>
          <path
            d="M539.79 562.48l.74-1 35-66.34.07-.7-15.41-29a2.87 2.87 0 00-5.36.91z"
            fill="#ffc24a"
          />
          <path
            d="M540.23 561.69l.56-1.09 34.6-65.65L560 465.88a2.6 2.6 0 00-4.94.9z"
            fill="#ffa712"
            fillRule="evenodd"
          />
          <path
            d="M586.81 516.3l11.47-11.76-11.48-21.91a3 3 0 00-5.21 0l-6.13 11.69v1z"
            fill="#f4bd62"
          />
          <path
            d="M586.6 515.81l11.16-11.43-11.16-21.25c-1.06-2-3.63-2.22-4.68-.2l-6.17 11.88-.18.6z"
            fill="#ffa50e"
            fillRule="evenodd"
          />
          <path
            fill="#f6820c"
            d="M539.79 562.48L540.13 562.14 541.34 561.65 586.09 517.07 586.65 515.53 575.49 494.26 539.79 562.48z"
          />
          <path
            d="M588.24 584.96l40.49-22.58-11.56-71.22a2.77 2.77 0 00-4.69-1.51l-72.69 72.83 40.26 22.48a8.41 8.41 0 008.19 0"
            fill="#fde068"
          />
          <path
            d="M628.37 562.19l-11.48-70.68c-.36-2.21-2.63-3.12-4.21-1.54l-72.44 72.37 39.82 22.26a8.32 8.32 0 008.12 0z"
            fill="#fcca3f"
          />
          <path
            d="M588.24 584.29a8.41 8.41 0 01-8.19 0l-39.94-22.15-.32.34 40.26 22.48a8.41 8.41 0 008.19 0l40.49-22.58-.1-.61z"
            fill="#eeab37"
          />
        </g>
      </svg>
    );
  }
}
